const downloadImage = ({data, name}: {data: string; name: string}) => {
    const a = document.createElement('a')
    a.href = data
    a.download = `${name}.jpeg`
    a.click()
    a.remove()
}

export default downloadImage
